import React from 'react';

const ProgressRing = () => {
  return (
    <div className="w-14 h-14 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center border-2 border-blue-200 shadow-sm">
      <span className="text-xs font-bold text-blue-700">0%</span>
    </div>
  );
};

export default ProgressRing;
